import classNames from 'classnames'
import * as React from 'react'

import Link from '@/components/Link'

const ButtonSwitch = ({items}) => {
  items = items || []

  return (
    <div className='body-s-medium flex rounded-[40px] '>
      {items.map(({_uid, label, link, active}, index) => {
        const Tag = active ? 'span' : Link
        return (
          <Tag
            key={_uid}
            link={link}
            className={classNames(
              'flex items-center gap-2 rounded-[40px] py-2 px-4',
              active
                ? 'bg-violet-600 text-white'
                : 'border border-violet-400 bg-white text-violet-600 hover:bg-violet-200 focus-visible:bg-violet-200',
              index === 0 ? 'relative' : '-ml-12 pl-16'
            )}
          >
            <span className='block'>{label}</span>
            {active ? (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='15'
                height='15'
                fill='none'
                viewBox='0 0 15 15'
              >
                <path
                  className='fill-yellow-400'
                  d='M14.43 7.5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-7.82 3.73 5.2-5.2a.48.48 0 0 0 0-.64l-.65-.63a.4.4 0 0 0-.63 0L6.3 9l-2-1.98a.4.4 0 0 0-.62 0l-.65.62a.48.48 0 0 0 0 .65l2.93 2.94c.17.17.48.17.65 0Z'
                />
              </svg>
            ) : (
              <span aria-hidden className={'h-[14px] w-[14px] rounded-full border'} />
            )}
          </Tag>
        )
      })}
    </div>
  )
}

export default ButtonSwitch
